import React, { Component } from 'react';
import ParametersContainer from '../../parametersContainer';
import ForgeView from '../../forgeView';

export default class StepConfigure extends Component {
    render() {
        return (
            <div className="inRow fullheight">
                <ParametersContainer
                    onCartUpdated={this.props.onCartUpdated}
                    onUpdateComplete={this.props.onUpdateComplete}
                />
                <ForgeView />
            </div>
        );
    }
}
